import React from 'react'
import { useParams} from "react-router-dom";


export default function Exam3() {
    // console.log(useParams());
    
    console.log(useParams())

    return (
        <div>
            <div>404 Not Found </div>
        </div>
    )
}
